import { createAction } from '@reduxjs/toolkit';
import { call, put, select, takeLatest } from 'redux-saga/effects';

import DiseaseApi from 'api/DiseaseApi';
import * as dto from 'client/dto';
import { AggregationCat } from 'models/DiseaseModels';
import { MapAggregationCat2Request } from 'utils/modelHelpers';

import diseaseActivitiesTimeFrameSelectors from 'diseaseActivitiesTimeFrame/diseaseActivitiesTimeFrame.selectors';
import diseaseActivityPanelsSelectors from 'diseaseActivityPanels/diseaseActivityPanels.selectors';
import { DiseaseActivityParams } from 'diseaseActivityPanels/diseaseActivityPanels.slice';

import {
  loadAllTemporalError,
  loadAllTemporalStart,
  loadAllTemporalSuccess,
  loadDiseaseActivityTemporalError,
  loadDiseaseActivityTemporalStart,
  loadDiseaseActivityTemporalSuccess,
} from './diseaseActivitiesTemporal.slice';

export const fetchAllTemporal = createAction('diseaseActivitiesTemporal/allTemporal');
export const fetchDiseaseActivitiesTemporal = createAction(
  'diseaseActivitiesTemporal/diseaseActivitiesTemporal'
);

export function* sagaFetchAllTemporal() {
  try {
    yield put(loadAllTemporalStart());
    const startDate: string = yield select(diseaseActivitiesTimeFrameSelectors.getStartDate);
    const aggregationCategory: AggregationCat = yield select(
      diseaseActivitiesTimeFrameSelectors.getAggregationCat
    );
    const disacParams: DiseaseActivityParams = yield select(
      diseaseActivityPanelsSelectors.disacParams
    );
    const isAnyLocationSelected: boolean = yield select(
      diseaseActivityPanelsSelectors.isAnyLocationSelected
    );

    const response: dto.DiseaseTemporalActivityModel[] = yield call(
      DiseaseApi.DiseaseRiskController_GetTemporalActivity,
      {
        ...MapAggregationCat2Request[aggregationCategory],
        activityStartDate: startDate,
        locationId: disacParams?.userLocationId,
        includeProximalActivity: isAnyLocationSelected,
        descriptionCountForAggregationTime: 0,
      }
    );

    yield put(loadAllTemporalSuccess(response));
  } catch (e) {
    yield put(loadAllTemporalError());
  }
}

export function* sagaFetchDiseaseActivitiesTemporal() {
  try {
    yield put(loadDiseaseActivityTemporalStart());
    const startDate: string = yield select(diseaseActivitiesTimeFrameSelectors.getStartDate);
    const aggregationCategory: AggregationCat = yield select(
      diseaseActivitiesTimeFrameSelectors.getAggregationCat
    );
    const disacParams: DiseaseActivityParams = yield select(
      diseaseActivityPanelsSelectors.disacParams
    );

    const response: dto.CountryTemporalActivityModel[] = yield call(
      DiseaseApi.DiseaseActivityController_GetTemporalActivityForDiseaseActivity,
      disacParams?.diseaseId,
      disacParams?.speciesId,
      {
        diseaseId: disacParams?.diseaseId,
        speciesId: disacParams?.speciesId,
        ...MapAggregationCat2Request[aggregationCategory],
        activityStartDate: startDate,
        activityEndDate: new Date().toISOString(),
        descriptionCountForAggregationTime: 0,
      }
    );

    yield put(loadDiseaseActivityTemporalSuccess(response));
  } catch (e) {
    yield put(loadDiseaseActivityTemporalError());
  }
}

function* diseaseActivitiesTemporalSaga() {
  yield takeLatest(fetchAllTemporal, sagaFetchAllTemporal);
  yield takeLatest(fetchDiseaseActivitiesTemporal, sagaFetchDiseaseActivitiesTemporal);
}

export default diseaseActivitiesTemporalSaga;
